import { createSlice } from "@reduxjs/toolkit";

const initialState = false;

export const errorSlice = createSlice({
    name: 'loader',
    initialState,
    reducers: {
        showLoader: () => {
            return true;
        }, 
        hideLoader: () => {
            return false
        }
    }
});

export const {showLoader, hideLoader} = errorSlice.actions;

export const isLoaderActive = (state) => state.loader;

export default errorSlice.reducer;